const $ = jQuery.noConflict();

class mobileFilters {
    constructor() {
        this.filterToggle = $('.events-calendar__topbar-panel-toggle');
        this.filterContainer = $('.event-calendar__top-bar');
    }

    init() {
        if ( ! $('.events-calendar__topbar-panel-toggle' ).length ) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.filterToggle.on( 'click', this.toggleFilters );
    }

    toggleFilters(e) {
        $('.event-calendar__top-bar').toggleClass('filters-open');
    }
}
export default new mobileFilters();
